module.exports = __webpack_public_path__ + "media/images/responsive/page_common/ranking_ribbon-bc4340812d0094657e3740d383fe46e1.png";